import { gql } from '@apollo/client';

export default gql`
  mutation createSpace($name: String!) {
    createSpace(input: { name: $name }) {
      space {
        id
        name
        role
      }
    }
  }
`;
